export interface BaseGenderRecognition {
  sector?: string;
  sucursal: string;
  tipo_acceso: 'perimetral' | 'interna';
}

export type BodyGenderRecognition = BaseGenderRecognition &
  (
    | {
        Tipo_consulta_BD: 'RANGO_DIAS';
        fecha_inicial: string;
        fecha_final: string;
        por_defecto?: string;
      }
    | {
        Tipo_consulta_BD: 'RANGO_MESES';
        mes_inicial: string;
        mes_final: string;
      }
    | {
        Tipo_consulta_BD: 'MES_ACTUAL';
        mes_actual: string;
      }
    | {
        Tipo_consulta_BD: 'MES_ANTERIOR';
        mes_anterior: string;
      }
    | {
        Tipo_consulta_BD: 'ANIO_ACTUAL';
        anio_actual: string;
      }
    | {
        Tipo_consulta_BD: 'ANIO_ANTERIOR';
        anio_anterior: string;
      }
  );

export interface ResponseGenderRecognition {
  'public_data': DataGenderRecognition;
}

export interface DataGenderRecognition {
  anio_base: string | number;
  accesos: GenderRecognition[];
}

export interface GenderRecognition {
  acceso: string;
  fechas: DataGenderHourly[];
  total_hombres: number;
  total_mujeres: number;
  total_visitantes: number;
  porcentaje_hombres: string;
  porcentaje_mujeres: string;
}

export interface DataGenderHourly {
  Hora: string;
  Hombres: number;
  Mujeres: number;
  Total: number;
}
